import { MdOutlineInfo } from "react-icons/md";
import Button from "../Buttons/Button";

interface ITitleEvaluations {
    label: string,
    onClick?: (e?: any) => void,
    textStyle?: string
}

const TitleEvaluations = ({ label, onClick, textStyle = 'text-llarge' }: ITitleEvaluations) => {
    return (
        <div className={`${textStyle} text-primary-10 flex items-center gap-1`}>
            <h4>{label}</h4>
            <Button
                label=''
                icon={MdOutlineInfo}
                iconSize={16}
                onClick={onClick}
                variant='none'
                className="!px-0 !h-full"
            />
        </div>
    )
}

export default TitleEvaluations